<template>
  <HeaderPart v-if="$route.path !== '/' && $route.path !== '/thermalPrint' && $route.path !== '/print' && $route.path !== '/A4' && $route.path !== '/measurementprint'"/>
  <router-view/>
  <FooterPart v-if="$route.path !== '/' && $route.path !== '/thermalPrint' && $route.path !== '/print' && $route.path !== '/A4' && $route.path !== '/measurementprint'"/>
</template>

<script>
import HeaderPart from '@/components/HeaderPart.vue'
import FooterPart from '@/components/FooterPart.vue'
import router from './router';
export default {
  
  components: {
    HeaderPart,FooterPart
  }
}
</script>

<style lang="scss"> 
.form-input{
  padding: 1px 15px;
  height: 2rem;
  text-transform: capitalize;
}

.form-input:focus{
  background: yellow;
}

button#saveBtn:focus {
    border: 1px solid red;
    background: red;
}
table{
  font-size: small;
}
#plusModal{
    z-index: 999;
}
#plusModal div{
    width: 100%;
        max-width: 800px;
}
.measurement_bg_card{
    overflow: scroll;
    display: block;
    height: 80%; 
}
.form-group{
    width: 25% !important;
}
</style>
